import { createContext, useContext, useEffect, useState } from 'react';
import { content } from '../content';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => localStorage.getItem('rs-lang') || 'fr');

    useEffect(() => {
        localStorage.setItem('rs-lang', lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const t = content[lang];

    return (
        <LanguageContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
